// biome-ignore lint/suspicious/noEmptyBlockStatements: noop
export const noop = () => {};
